import { AiOutlineClose } from 'react-icons/ai';
import ParsedReceiptResult from './ParsedReceiptResult';
import { type Receipt } from '../../../common/types';
import { useTranslation } from 'react-i18next';
import HorizontalDivider from '../../devices/components/HorizontalDivider';
import format from 'date-fns/format';

interface IProps {
  isOpen: boolean;
  toggleModal: () => any;
  item: Receipt | null;
}

const ReceiptInfo: React.FC<IProps> = ({ item, isOpen, toggleModal }) => {
  const { t } = useTranslation();
  return (
    <>
      {isOpen && item != null ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="my-6 mx-auto w-1/2">
              <div className="border-0 rounded-lg shadow-lg flex flex-col bg-white outline-none focus:outline-none">
                <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-3xl font-semibold">{t('receipts.info.title')}</h3>
                  <button
                    className="p-1 ml-auto border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={toggleModal}
                  >
                    <AiOutlineClose size={20} />
                  </button>
                </div>

                <div className="flex flex-col space-y-2 p-4 whitespace-pre-wrap">
                  <div className="flex flex-row space-x-2">
                    <span className="font-bold">Status</span>
                    <span>{item.status}</span>
                  </div>
                  <div className="flex flex-row space-x-2">
                    <span className="font-bold">Last Processed At</span>
                    <span>{format(new Date(item.processedDate), 'yyyy-MM-dd HH:mm')}</span>
                  </div>
                  <HorizontalDivider />
                  <div className="flex flex-col max-h-64 overflow-y-auto">
                    <span className="font-bold">Receipt</span>
                    <span>{item.receipt}</span>
                  </div>
                  <HorizontalDivider />
                  <div className="flex flex-col max-h-64 overflow-y-auto">
                    <span className="font-bold">Parsed Result</span>
                    {item.parsedResult !== null && <ParsedReceiptResult result={item.parsedResult} />}
                  </div>
                </div>

                <div className="w-full flex justify-end px-4 space-x-2 py-6 mt-4 border-t border-solid border-slate-200 rounded-b">
                  <button className="text-primary text-black px-5 py-2 rounded-lg bg-gray-200" onClick={toggleModal}>
                    {t('receipts.info.okayBtnLabel')}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default ReceiptInfo;
